import React, { FC, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { XCircle } from 'lucide-react';
import styles from './styles.module.css';
import * as translations from './strings';
import { getLangKey } from '../../../../models/Language';
import { WhyModal } from './whyModal';

const strings = translations[getLangKey()];

export type IntegrationCardError = {
  message: string;
  created_at?: string;
};

type ErrorDetailsProps = {
  error?: IntegrationCardError;
  createError?: string;
};

export const ErrorDetails: FC<ErrorDetailsProps> = ({
  error,
  createError = ''
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        className={styles.errorLink}
        type="link"
        size="small"
        onClick={() => setIsModalOpen(true)}
      >
        {strings.seeError}
      </Button>
      <WhyModal
        setIsModalOpen={setIsModalOpen}
        error={error}
        createError={createError}
        isModalOpen={isModalOpen}
      />
    </>
  );
};

type Props = {
  error?: IntegrationCardError;
  createError: string;
  container: HTMLDivElement;
  onRetry: () => void;
  retrying?: boolean;
};

const Error: FC<Props> = ({
  error,
  createError,
  container,
  onRetry,
  retrying = false
}) => (
  <div className={styles.errorContainer}>
    <div className={styles.errorMessage}>
      <Tooltip
        getPopupContainer={() => container}
        title={error?.message || createError}
        placement="bottomLeft"
        overlayClassName={styles.tooltip}
      >
        <XCircle className={styles.errorIcon} />
      </Tooltip>
      <span className={styles.errorText}>{strings.couldntSend}.</span>
      <ErrorDetails error={error} createError={createError} />
    </div>
    <Button
      className={styles.errorLink}
      type="link"
      size="small"
      loading={retrying}
      onClick={onRetry}
    >
      {strings.retry}
    </Button>
  </div>
);

export default Error;
